import { defineComponent } from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import { ContextActionTypes, ContextGetterTypes, ContextModuleState } from '~/store/account/context'
import { Context, VcsProviderChoices } from '~/types/types'

export default defineComponent({
  name: 'ContextMixin',

  computed: {
    ...(mapState<ContextModuleState>('account/context', {
      context: (state: ContextModuleState) => state.context as Context
    }) as {
      context: () => Context
    }),
    ...mapGetters('account/context', {
      toOnboard: ContextGetterTypes.TO_ONBOARD,
      contextInstallationUrl: ContextGetterTypes.INSTALLATION_URL
    }),
    installationUrls(): Record<string, string> {
      return {
        ...this.context.installationUrls,
        [this.$providerMetaMap[VcsProviderChoices.BitbucketDatacenter].value]:
          '/accounts/bbd/login',
        [this.$providerMetaMap[VcsProviderChoices.Gitlab].value]: '/accounts/gitlab/login',
        [this.$providerMetaMap[VcsProviderChoices.Gsr].value]: '/accounts/gsr/projects',
        [this.$providerMetaMap[VcsProviderChoices.Ads].value]: '/accounts/ads/login'
      }
    }
  },

  async fetch(): Promise<void> {
    await this.fetchContext()
  },

  methods: {
    ...mapActions('account/context', {
      fetchContext: ContextActionTypes.FETCH_CONTEXT,
      fetchToOnboard: ContextActionTypes.FETCH_TO_ONBOARD
    })
  }
})
